import { Navigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux-store/appStore';
import ScheduledInspectionList from 'src/pages/Permits/Construction/Inspection/ScheduledInspectionList';
import {
  canAccessInspectionSchedule,
  getPermitFeatureDeniedRedirect,
  isPermitFeatureTownshipAllowed
} from 'src/utils/permitFeatureAccess';

const InspectionScheduleRoute = () => {
  const { townshipId, permit } = useParams<{ townshipId: string; permit: string }>();
  const userDetails = useSelector((store: RootState) => store.user.userDetails);

  if (!canAccessInspectionSchedule(userDetails, Number(permit))) {
    return (
      <Navigate
        to={getPermitFeatureDeniedRedirect(userDetails)}
        replace
      />
    );
  }

  if (!isPermitFeatureTownshipAllowed(userDetails, townshipId)) {
    return (
      <Navigate
        to={getPermitFeatureDeniedRedirect(userDetails)}
        replace
      />
    );
  }

  return <ScheduledInspectionList />;
};

export default InspectionScheduleRoute;
